<template>
  <div class="main">
    <div class="main-top">
        <div class="condition">
            <div class="condition-item">
                <div class="label">查询:</div>
                <el-input v-model="conditionData.Keyword" size="mini" placeholder="请输入内容"></el-input>
            </div> 
            <!-- <div class="condition-item">
                <div class="label">类型:</div>
                <el-select v-model="conditionData.AssetsCaseType" placeholder="请选择" size="small">
                    <el-option
                    v-for="item in AssetsCaseTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>  -->
            <div class="condition-item">
                <div class="label">开始时间:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div> 
            <div class="condition-item">
                <div class="label">结束时间:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="condition-btns">
                <el-button type="primary" size="mini" @click="selectLoadingData()">查询</el-button>
                <el-button type="warning" size="mini" @click="reset()">重置</el-button>
            </div>
        </div>
    </div>
    <div class="main-main">
            <!-- :header-cell-style="tableHeaderColor" -->

        <el-table
            :data="list"
            border
            @selection-change="handleSelectionChange"
            style="width: 100%">
           
           <el-table-column
            type="index"
            width="55"
            label="序号"
            align="center"
            >
            </el-table-column>

            <el-table-column
            prop="company"
            label="作业单位"
            width="200"
            align="center"
            :show-overflow-tooltip="true"
            >
            </el-table-column>
            
            <el-table-column
            prop=""
            label="公检法"
            align="center"
            >
                <el-table-column
                prop="gjf.car"
                label="车辆"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="gjf.damage"
                label="物损"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="gjf.other"
                label="其他"
                align="center"
                >
                </el-table-column>
            </el-table-column>

            <el-table-column
            prop=""
            label="社会个体"
            align="center"
            >
                <el-table-column
                prop="shgt.car"
                label="车辆"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="shgt.damage"
                label="物损"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="shgt.other"
                label="其他"
                align="center"
                >
                </el-table-column>
            </el-table-column>

            <el-table-column
            prop=""
            label="保险主体"
            align="center"
            >
                <el-table-column
                prop="bxzt.car"
                label="车辆"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="bxzt.damage"
                label="物损"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="bxzt.other"
                label="其他"
                align="center"
                >
                </el-table-column>
            </el-table-column>

            

            <el-table-column
            prop="total"
            label="总计"
            align="center"
            >
            </el-table-column>
        </el-table>
    </div>
    <!-- <div class="page">
        <el-pagination
         @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="totalCount"
            :current-page="conditionData.page"
            :page-size="conditionData.pageSize">
        </el-pagination>
        <div class="handle">
        </div>
    </div> -->
    
   
    
  </div>
</template>

<script>
import api from '../../../api/main'

export default {
    name: 'customer',
    data () {
        return {
            totalCount:0,
            conditionData:{
                // AssetsCaseType:1,
                StartTime:'',
                EndTime:'',
                Keyword:'',
                page: 1,
                pageSize: 10,
            },
            selectList:[],
            list:[],
            AssetsCaseTypeList:[
                {
                    label:'评估',
                    value:1,
                },{
                    label:'财产险',
                    value:2,
                },{
                    label:'调查',
                    value:3,
                }
            ],
        }
    },
    created(){},
    mounted(){
        this.loadingData();
    },
    computed:{
        
    },
    watch:{
        
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        selectLoadingData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        handleSelectionChange(list){
            this.selectList = list;
        },
        async loadingData() {
            let res  = await api.evaluationSection(this.conditionData);
            this.list = res.data.data;
        },
        
        reset(){
            this.conditionData={
                // AssetsCaseType:1,
                StartTime:'',
                EndTime:'',
                Keyword:'',
                page: 1,
                pageSize: 10,
            };
            this.loadingData();
        },
        
        
        
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
    .condition{
        padding:10px 15px;
        font-size: 14px;
        display: flex;
        flex-wrap: wrap;
        background-color: #fff;

    }
    .condition-item{
        margin: 5px;
        margin-left: 20px;
        display: flex;
        align-items: center;
        .label{
            width: 120px;
            
        }
        .labelmini{
            width: 80px;
        }
    }
    .condition-btns{
        margin: 5px;
        margin-left: 10px;
    }
    .main-main{
        background-color: #fff;
        /* padding:15px; */
        margin-top: 15px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
            /deep/.el-tabs__header{
                margin: 0;
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .page{
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding:13px 5px;
        margin-top: 15px;
    }
    .handle{
        padding-right: 10px;
    }
    .dialog{
        .item{
            display:flex;
            padding-bottom: 15px;
            .label{
                width: 120px;
                font-size: 14px;
                line-height: 14px;
                display: flex;
                align-items: center;
            }
            .item-r{
                width: 100%;
            }
            .con{
                width: 400px;
                font-size: 14px;
            }
            .con-n{
                font-weight: bold;
                font-size: 14px;
            }
            img{
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
        }
    }
</style>

